// THE SCROLL A PAGE SITS IN, FOUND RATHER THAN NAMED. A step of the request
// wizard scrolls inside the drawer's panel today and scrolled the window when
// it was a page; the next tenant of the drawer may be either. A step opening
// at its top (Freddi, 2026-10-09: "opening the next page … some appears out
// of view") cannot depend on knowing which, so it asks the tree: the nearest
// ancestor that scrolls, else the window.

const SCROLLS = new Set(['auto', 'scroll']);

/** The nearest ancestor whose `overflow-y` scrolls, or null when only the window does. */
export function scrollParentOf(el: Element | null, style: (e: Element) => CSSStyleDeclaration = (e) => getComputedStyle(e)): Element | null {
  for (let node = el?.parentElement ?? null; node; node = node.parentElement) {
    if (SCROLLS.has(style(node).overflowY)) return node;
  }
  return null;
}

/** Put the scroll `el` sits in back to its top — the ancestor that scrolls, or the window. */
export function scrollToTopOf(
  el: Element | null,
  deps: { style?: (e: Element) => CSSStyleDeclaration; win?: Pick<Window, 'scrollTo'> } = {},
): void {
  const parent = scrollParentOf(el, deps.style);
  if (parent) {
    parent.scrollTop = 0;
    return;
  }
  (deps.win ?? (typeof window !== 'undefined' ? window : null))?.scrollTo(0, 0);
}
